export enum PayerReview {
  None = 'None',
  ReviewWithoutIE = 'reviewWithoutIE',
  ReviewWithIE = 'reviewWithIE',
  ReviewWithOffer = 'reviewWithOffer',
  ReviewWithoutOffer = 'reviewWithoutOffer',
}
